import app from '$$app';

const blockedEvents = [
  'TaskResourceUnassigned',
  'TaskResourceAssigned',
  'TaskResourceUpdated',
  'TaskDeleted',
  'TaskCreated',
  'TaskUpdated',
  'TaskCustomFieldUpdated',
  'TaskTimeLogsCreated',
  'TaskTimeLogDeleted',
  'TaskTimeLogUpdated',
  'TaskCommentCreated',
  'TaskCommentDeleted',
  'TaskAttachementCreated',
  'TaskAttachementDeleted',
  'TaskLinkDeleted',
  'TaskLinkCreated',

  'CustomFieldToProjectAssigned',
  'CustomFieldFromProjectUnassigned',
  'CustomFieldUpdated',
  'CustomFieldCreated',
  'CustomFieldDeleted',

  'ResourceToProjectsAssigned',
  'ResourceFromProjectsUnassigned',
  'ResourceDeleted',
  'ResourceCreated',
  'ResourceUpdated',
  'ResourceOnProjectsUpdated',
  'ResourceRoleUpdated',
  'ResourcesOnProjectsConverted',

  'ProjectCalendarUpdated',
  'ProjectArchived',
  'ProjectConfigUpdated'
];

function activateBlockListheners(activateCollback) {
  app.on('gantt:inlineEditor:opened', (mode, taskId, ganttId, parentId, columnName, isCustomColumn, isUserCustomColumn) => {
    activateHandler(mode, taskId, ganttId, parentId, columnName, isCustomColumn, isUserCustomColumn);
  });

  function activateHandler(mode = 'edit', taskId, ganttId, parentId, columnName, isCustomColumn, isUserCustomColumn) {
    const collbackParams = { mode, type: 'gantt', events: blockedEvents };

    if (mode === 'create') {
      collbackParams.parent_id = parentId;
    }

    if (mode === 'edit') {
      collbackParams.task_id = +taskId;
      collbackParams.gantt_id = +ganttId;

      collbackParams.column_id = columnName;

      if (isCustomColumn) {
        collbackParams.customColumn = true;
      }

      if (isUserCustomColumn) {
        collbackParams.userCustomColumn = true;
        collbackParams.column_id = +columnName;
      }
    }

    activateCollback(collbackParams);
  }
}

function deactivateBlockListheners(deactivateCollback) {
  app.on('gantt:inlineEditor:closed', deactivateCollback);
}

export default {
  activateBlockListheners,
  deactivateBlockListheners,
};
